import {
  Datagrid,
  EditButton,
  List,
  ListProps,
  TextField,
  TextInput,
} from "react-admin";
import { StandardPagination } from "../../common/StandardPagination";

export const ListStatuses: React.FC<ListProps> = (props) => {
  const filters = [<TextInput key="name" label="Nombre" source="name" alwaysOn />];

  return (
    <List
      {...props}
      perPage={10}
      filters={filters}
      pagination={<StandardPagination />}
    >
      <Datagrid optimized>
        <TextField source="name" label="Nombre" />
        <EditButton label="Editar" />
      </Datagrid>
    </List>
  );
};
